import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../constants/report.css";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader } from "../../../components";
import useScreenWidth from "../../../hooks/useScreenWidth";
import { postRequest } from "../../../constants/api";
import { formatDate } from "../../../constants/helper";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";

const LapProyekSemua = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  const [arsitekId, setArsitekId] = useState("");
  const [namaArsitek, setNamaArsitek] = useState("");

  const [arsiteks, setArsiteks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapProyekSemuasData, setLapProyekSemuasData] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  const createEmptySpreadsheetRow = () => ({
    id: null,
    namaCustomer: "",
    tglDpDate: null,
    noRab: "",
    pekerjaan: "",
    pekerjaanChild: "",
    ukuran: "",
    satuan: "",
    keterangan: "",
    kirimGambar: "",
    kirimGambarDate: null,
    kirimGambarMenunggu: false,
    revisi: "",
    revisiDate: null,
    revisiNotes: "",
    revisiMenunggu: false,
    po: "",
    poDate: null,
    poNotes: "",
    poMenunggu: false,
    masukProduksi: "",
    masukProduksiDate: null,
    masukProduksiMenunggu: false,
    produksi: "",
    produksiDate: null,
    produksiMenunggu: false,
  });
  const spreadsheetHeaders = [
    { key: "namaCustomer", label: "NAMA" },
    { key: "tglDpDate", label: "TGL DP" },
    { key: "noRab", label: "NO. RAB" },
    { key: "pekerjaan", label: "PEKERJAAN" },
    { key: "ukuran", label: "UKURAN" },
    { key: "keterangan", label: "KETERANGAN" },
    { key: "kirimGambar", label: "KIRIM GBR" },
    { key: "revisi", label: "REVISI GBR / MOCK-UP" },
    { key: "po", label: "PO / ACC GBR" },
    { key: "masukProduksi", label: "PRODUKSI (ARSITEK KE YESI)" },
    { key: "produksi", label: "PRODUKSI (YESI KE RENDY)" },
  ];
  const [spreadsheetRows, setSpreadsheetRows] = useState([
    createEmptySpreadsheetRow(),
  ]);

  let arsitekOptions = arsiteks.map((arsitek) => ({
    label: arsitek.namaArsitek,
    id: arsitek.id,
  }));

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      let neracas = await postRequest(`/lapProyekSemua`, {
        arsitekId,
      });
      setLapProyekSemuasData(neracas.data);
      setPreviewPdf(!previewPdf);
      setLoading(false);
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    getArsiteksData();
  }, []);

  const getArsiteksData = async () => {
    const response = await postRequest(`/arsiteks`, {});
    setArsiteks(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LapProyekSemua",
    sheet: "LapProyekSemua",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  const list = [];
  for (let j = 0; j < lapProyekSemuasData.length; j++) {
    list.push(
      <tr style={tableText}>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
      </tr>
    );
    list.push(
      <tr style={tableText}>
        <td style={{ border: "1px solid black" }}>
          <div>
            <b>{lapProyekSemuasData[j].customer.namaCustomer}</b>
          </div>
          <div>{lapProyekSemuasData[j].customer.alamatCustomer}</div>
          <div>{lapProyekSemuasData[j].customer.teleponCustomer}</div>
        </td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
        <td style={{ border: "1px solid black" }}></td>
      </tr>
    );

    for (let item of lapProyekSemuasData[j].items) {
      let tempPekerjaan = <b>{item.pekerjaan}</b>;
      if (!item.pekerjaan) {
        tempPekerjaan = `${
          item.pekerjaanChild ? `- ${item.pekerjaanChild}` : ""
        }`;
      }

      let returnKirimGambar = "";
      if (item.kirimGambar) {
        returnKirimGambar += `(${item.kirimGambar}) : `;
      }
      if (item.kirimGambarDate) {
        returnKirimGambar += `${formatDate(item.kirimGambarDate)}`;
      }

      let returnRevisi = "";
      if (item.revisi) {
        returnRevisi += `(${item.revisi}) : `;
      }
      if (item.revisiDate) {
        returnRevisi += `${formatDate(item.revisiDate)} : `;
      }
      if (item.revisiNotes) {
        returnRevisi += `${item.revisiNotes}`;
      }

      let returnPo = "";
      if (item.po) {
        returnPo += `(${item.po}) : `;
      }
      if (item.poDate) {
        returnPo += `${formatDate(item.poDate)} : `;
      }
      if (item.poNotes) {
        returnPo += `${item.poNotes}`;
      }

      let returnMasukProduksi = "";
      if (item.masukProduksiDate) {
        returnMasukProduksi += `${formatDate(item.masukProduksiDate)} : `;
      }
      if (item.masukProduksi) {
        returnMasukProduksi += `${item.masukProduksi}`;
      }

      let returnProduksi = "";
      if (item.produksiDate) {
        returnProduksi += `${formatDate(item.produksiDate)} : `;
      }
      if (item.produksi) {
        returnProduksi += `${item.produksi}`;
      }

      list.push(
        <tr style={tableText}>
          <td style={{ border: "1px solid black" }}></td>
          <td style={{ border: "1px solid black" }}>
            {item.tglDpDate ? formatDate(item.tglDpDate) : ""}
          </td>
          <td style={{ border: "1px solid black" }}>{item.noRab}</td>
          <td style={{ border: "1px solid black", minWidth: "200px" }}>
            {tempPekerjaan}
          </td>
          <td style={{ border: "1px solid black" }}>
            {item.ukuran} {item.satuan}
          </td>
          <td style={{ border: "1px solid black" }}>{item.keterangan}</td>
          <td
            style={{
              backgroundColor: item.kirimGambarMenunggu && "#ffff66",
              border: "1px solid black",
            }}
          >
            {returnKirimGambar}
          </td>
          <td
            style={{
              backgroundColor: item.revisiMenunggu && "pink",
              border: "1px solid black",
            }}
          >
            {returnRevisi}
          </td>
          <td
            style={{
              backgroundColor: item.poMenunggu && "pink",
              border: "1px solid black",
            }}
          >
            {returnPo}
          </td>
          <td
            style={{
              backgroundColor: item.masukProduksiMenunggu && "#ffff66",
              border: "1px solid black",
            }}
          >
            {returnMasukProduksi}
          </td>
          <td
            style={{
              backgroundColor: item.produksiMenunggu && "#99ff99",
              border: "1px solid black",
            }}
          >
            {returnProduksi}
          </td>
        </tr>
      );
    }
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Proyek Semua</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Arsitek :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={arsitekOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && arsitekId.length === 0 && true}
                        size="small"
                        placeholder="SEMUA ARSITEK"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setArsitekId(value.id);
                        setNamaArsitek(value.label);
                      } else {
                        setArsitekId("");
                        setNamaArsitek("");
                      }
                      setPreviewPdf(false);
                    }}
                    defaultValue={namaArsitek}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Proyek Semua
          </h5>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th colSpan={3} style={{ border: "1px solid black" }}>
                  PROYEK
                </th>
                <th colSpan={3} style={{ border: "1px solid black" }}>
                  PEKERJAAN
                </th>
                <th colSpan={5} style={{ border: "1px solid black" }}>
                  TANGGAL
                </th>
              </tr>
              <tr>
                {spreadsheetHeaders.map((column) => (
                  <th key={column.key} style={{ border: "1px solid black" }}>
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LapProyekSemua;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};
